import { Component, OnInit, Output ,EventEmitter} from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserModel } from 'src/app/model/UserModel';
import { DataServiceService } from 'src/app/services/data-service.service';

@Component({
  selector: 'app-admin-top',
  templateUrl: './admin-top.component.html',
  styleUrls: ['./admin-top.component.css']
})
export class AdminTopComponent implements OnInit {
  fullname: string;
  selectedVal:string = "DATA";

  actTypeSelec:boolean;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private dataServiceService:DataServiceService) {
    let currentUser: UserModel = this.authenticationService.getCurrentUser();
    currentUser.LastName = currentUser.LastName ? currentUser.LastName : "";

    this.fullname = currentUser.FirstName + " " + currentUser.LastName;
console.log('currntuse top');
    console.log(currentUser);

    // Toggler
    this.dataServiceService.currentAccountType.subscribe(mess => {
     
      this.actTypeSelec =mess=="VOICE" ? false: true;
     
      
     });
  

  }
  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/']);

  }

  toggleClick(event: Event)
  {
  
    this.selectedVal = this.actTypeSelec? "VOICE" : "DATA";
    this.dataServiceService.changeAccountTypeSelection(this.selectedVal);
  }


  ngOnInit() {
  }

}
